<div class="page-container">
    <app-navbar></app-navbar>
    <div class="main">
      <router-outlet></router-outlet>
    </div>
  </div>
